export enum Country {
    NL = 0,
    BE = 1,
    FR = 2,
    DE = 3,
    LX = 4,
    UNKNOWN = 5,
}

export const CountryOptions = [
    { value: Country.UNKNOWN, label: 'core.country.unknown' },
    { value: Country.NL, label: 'core.country.nl' },
    { value: Country.BE, label: 'core.country.be' },
    { value: Country.FR, label: 'core.country.fr' },
    { value: Country.DE, label: 'core.country.de' },
    { value: Country.LX, label: 'core.country.lx' },
]